<template>
  <div class="countdown">
    <!-- <span class="countdown-text">Unlock after: </span> -->
    <div class="countdown-row" v-if="!day_show">
      <div class="countdown-time-box">{{ hour_show }}</div>
      <span>:</span>
      <div class="countdown-time-box">{{ minute_show }}</div>
      <span>:</span>
      <div class="countdown-time-box">{{ second_show }}</div>
    </div>
    <div class="countdown-row" v-else>
      <div class="countdown-row-day">{{ day_show }}</div>
      <span>days</span>
    </div>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref, computed } from "vue";
import _ from "lodash";
export default {
  components: {},
  props: {
    unlock_secs: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    unlock_secs: {
      handler(value) {
        if (!value) {
          return;
        }
        this.init(value);
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const { begin_time, end_time } = props;

    const day_show = ref(false);
    const hour_show = ref("00");
    const minute_show = ref("00");
    const second_show = ref("00");

    let timer = null;
    const timeDiff = ref(0); //时间差

    onMounted(() => {
      
    });

    const init = (second)=>{
      getArtDate(second);
      if(timer == null){
        timer = setInterval(countDown, 1000);
        // console.log("initinitinitinitinitinitinitinitinitinitinitinitinitinit");
      }else {
        // console.log('timer init 拦截成功');
      }
      
    }


    /**
     * 获取公募开始结束时间
     */
    const getArtDate = async (second) => {
      // console.log(second);
      timeDiff.value = second;
      countDown();
    };

    /**
     * 处理格式化
     * @param i
     * @returns
     */
    function addZero(i) {
      return i < 10 ? "0" + i : i;
    }

    /**
     * 处理倒计时
     */
    const countDown = function () {
      if (timeDiff.value <= 0) {
        timer && clearTimeout(timer);
        timer = null;
        emit('timeout');
        return;
      }
      timeDiff.value = timeDiff.value - 1;
      let timeLeaf = timeDiff.value;
      
      let hour = Math.floor(timeLeaf / (60 * 60));
      timeLeaf = timeLeaf % 3600;

      if(hour > 24){
        // 显示天
        day_show.value = Math.floor(hour / 24);
      }else{
        // 显示时分秒
        let minute = Math.floor(timeLeaf / 60);
        timeLeaf = timeLeaf % 60;

        let second = Math.floor(timeLeaf);
        hour_show.value = addZero(hour);
        second_show.value = addZero(second);
        minute_show.value = addZero(minute);
        day_show.value = false;
      }
    };

    return {
      hour_show,
      second_show,
      minute_show,
      day_show,
      init
    };
  },
};
</script>

<style lang="less" scoped>
//阻止长按操作
.longTouch {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
.countdown {
  opacity: 1;
  position: absolute;
  width: auto;
  top: 33px;
  left: 11px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  font-family: "PingFang SC";
  line-height: 14.4px;
  width: 53px;
  height: 15px;
  letter-spacing: 2px;

  &-row{
    display: flex;
    align-items: center;
    &-day{
      font-size: 22px;
      margin-right: 3px;
      padding-bottom: 6px;
    }
  }
  &-time-box{
    // width: 19px;
    // height: 19px;
    // border-radius: 4.72px;
    // border: 0.8px solid #b6b9bcff;
    // background: #ffffff;
    // color: #484C58;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // margin: 0 6px;
  }
}
</style>
